import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseOfferBlock } from '../blocks.types'

export const CategoryTabsBlockFragment: BlockFragment = {
  name: 'categoryTabs',
  fragment: gql`
    fragment categoryTabs on CategoryTabs {
      id
      blockName
      blockType
      categories {
        id
        name
        slug
        logo {
          url
          alt
        }
        position
        icon
      }
      limit
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on CategoryTabs {
      id
      blockName
      blockType
      categories {
        id
        name
        slug
        logo {
          url
          alt
        }
        position
        icon
      }
      limit
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const CategoryTabsBlockType = 'categoryTabs'

export interface CategoryTabsBlock extends BaseOfferBlock {
  blockType: typeof CategoryTabsBlockType
  categories: {
    id: string
    name: string
    slug: string
    logo?: {
      url: string
      alt: string
    }
    position: number
    icon?: string
  }[]
  limit: number
}
